/* eslint-disable no-unused-vars */
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Badge } from '../../components/ui/badge';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { Textarea } from '../../components/ui/textarea';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../../components/ui/tabs';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from '../../components/ui/dialog';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../components/ui/select';
import { Switch } from '../../components/ui/switch';
import {
  DollarSign, Edit2, Trash2, Save, Plus, RefreshCw, Download, Upload,
  ShoppingCart, MapPin, Building2, Briefcase, Tag, BarChart3, Settings,
  TrendingUp, TrendingDown, CheckCircle, XCircle, AlertTriangle, Eye,
  Globe, Filter, Search, Calculator, Percent, Euro, Target, Layers,
  FileSpreadsheet, FileJson, Copy, Archive, Clock, Users, Activity,
  Recycle, Loader2, Coins
} from 'lucide-react';
import axios from 'axios';
import TypesMaitresManager from '../../components/TypesMaitresManager';
import ReferentielsManager from '../../components/ReferentielsManager';
import { toast } from 'sonner';
import {
  TARIF_TYPES, TERRITOIRES, TYPES_ENTREPRISES, ACTIVITES_PROFESSIONNELLES,
} from '../GestionTarifsDemandesPubliques.constants';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const DemandeDialog = ({ ctx }) => {
  const {
    activeTab, tarifs, tarifsParTerritoire, tarifsParType, tarifsParEntreprise,
    configParTypeBySpace, activeSpaceTarif, dirtyTypeBySpace, configParEntreprise,
    configParTerritoire, demandes, stats, loading, searchTerm, selectedTerritoire,
    selectedType, selectedStatut, tarifDialogOpen, editingTarif, statsDialogOpen,
    tarifForm, territoiresList, typesEntrepriseList, typesDemandeList, remisesPolitique,
    remisesPolitiqueLoading, viewDialogOpen, viewingDemande, demandeDialogOpen,
    editingDemande, demandeForm, programmees, programmeesLoading, tickNow,
    setActiveTab, setTarifs, setTarifsParTerritoire, setTarifsParType, setTarifsParEntreprise,
    setConfigParTypeBySpace, setActiveSpaceTarif, setDirtyTypeBySpace, setConfigParEntreprise,
    setConfigParTerritoire, setDemandes, setStats, setLoading, setSearchTerm, setSelectedTerritoire,
    setSelectedType, setSelectedStatut, setTarifDialogOpen, setEditingTarif, setStatsDialogOpen,
    setTarifForm, setTerritoiresList, setTypesEntrepriseList, setTypesDemandeList, setRemisesPolitique,
    setRemisesPolitiqueLoading, setViewDialogOpen, setViewingDemande, setDemandeDialogOpen,
    setEditingDemande, setDemandeForm, setProgrammees, setProgrammeesLoading, setTickNow,
    fetchAllData, fetchConfigTerritoires, fetchConfigTypesAllSpaces, fetchDemandes, fetchProgrammees,
    fetchStats, fetchTarifs, filteredDemandes, formatCountdown, getTerritoireInfo, getTypeInfo,
    handleAdminDeleteDemande, handleAdminDuplicateDemande, handleAdminEditDemande, handleCancelSchedule,
    handleCloneFromDefault, handleDeleteTarif, handleDuplicateTarif, handleExport, handlePublishNow,
    handleSaveAdminDemande, handleSaveAllConfigTypeSpace, handleSaveConfigEntreprise,
    handleSaveConfigTerritoire, handleSaveConfigType, handleSaveTarif, handleToggleTarif, handleViewDemande,
    loadReferentielsFromApi, loadRemisesPolitique, openEditDialog, parseActivitesFromDemande,
    resetTarifForm, saveRemisesPolitique, toggleActivite, updateConfigEntreprise, updateConfigTerritoire,
    updateConfigType, SPACES_TARIF, getAuthHeader, emptyTypeConfig,
  } = ctx;
  return (
      <Dialog open={demandeDialogOpen} onOpenChange={setDemandeDialogOpen}>
        <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <ShoppingCart className="h-5 w-5 text-emerald-600" />
              {editingDemande ? 'Modifier la demande' : 'Nouvelle demande publique'}
            </DialogTitle>
            <DialogDescription>
              {editingDemande ? `ID : ${editingDemande.id}` : 'Creation manuelle par Super Admin.'}
            </DialogDescription>
          </DialogHeader>
          <div className="space-y-4 py-2">
            <div className="space-y-1.5">
              <Label className="text-xs font-semibold">Titre *</Label>
              <Input
                value={demandeForm.title}
                onChange={(e) => setDemandeForm({ ...demandeForm, title: e.target.value })}
                placeholder="Titre de la demande"
                data-testid="demande-form-title"
              />
            </div>
            <div className="space-y-1.5">
              <Label className="text-xs font-semibold">Description</Label>
              <Textarea
                rows={3}
                value={demandeForm.description}
                onChange={(e) => setDemandeForm({ ...demandeForm, description: e.target.value })}
                placeholder="Description detaillee..."
                data-testid="demande-form-description"
              />
            </div>
            <div className="grid grid-cols-3 gap-3">
              <div className="space-y-1.5">
                <Label className="text-xs font-semibold">Territoire</Label>
                <Select value={demandeForm.territoire} onValueChange={(v) => setDemandeForm({ ...demandeForm, territoire: v })}>
                  <SelectTrigger><SelectValue/></SelectTrigger>
                  <SelectContent>
                    {territoiresList.map((t) => (<SelectItem key={t.value} value={t.value}>{t.label}</SelectItem>))}
                  </SelectContent>
                </Select>
              </div>
              <div className="space-y-1.5">
                <Label className="text-xs font-semibold">Type entreprise</Label>
                <Select value={demandeForm.type_entreprise} onValueChange={(v) => setDemandeForm({ ...demandeForm, type_entreprise: v })}>
                  <SelectTrigger><SelectValue/></SelectTrigger>
                  <SelectContent>
                    <SelectItem value="all">Tous</SelectItem>
                    {typesEntrepriseList.map((t) => (<SelectItem key={t.value} value={t.value}>{t.label}</SelectItem>))}
                  </SelectContent>
                </Select>
              </div>
              <div className="space-y-1.5">
                <Label className="text-xs font-semibold">Type demande</Label>
                <Select value={demandeForm.type_demande} onValueChange={(v) => setDemandeForm({ ...demandeForm, type_demande: v })}>
                  <SelectTrigger><SelectValue/></SelectTrigger>
                  <SelectContent>
                    {typesDemandeList.map((t) => (<SelectItem key={t.value} value={t.value}>{t.icon ? `${t.icon} ` : ''}{t.label}</SelectItem>))}
                  </SelectContent>
                </Select>
              </div>
            </div>
            {/* V37.27 — Activités professionnelles (multi-select) */}
            <div className="rounded-xl border border-slate-200 bg-amber-50/40 p-3 space-y-3" data-testid="demande-form-activites-section">
              <div className="flex items-center justify-between gap-2">
                <div className="text-[11px] font-bold uppercase tracking-wider text-slate-600 flex items-center gap-1.5">
                  <Briefcase className="h-3.5 w-3.5 text-amber-600" /> Activités professionnelles
                </div>
                <Badge variant="outline" className="text-[10px]" data-testid="activites-count">
                  {(demandeForm.activites || []).length} sélectionnée{((demandeForm.activites || []).length) > 1 ? 's' : ''}
                </Badge>
              </div>
              <p className="text-[11px] text-slate-500 -mt-1">Cochez une ou plusieurs activités correspondant au demandeur.</p>
              <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-2">
                {ACTIVITES_PROFESSIONNELLES.map((act) => {
                  const checked = (demandeForm.activites || []).includes(act.value);
                  return (
                    <button
                      type="button"
                      key={act.value}
                      onClick={() => toggleActivite(act.value)}
                      data-testid={`activite-chip-${act.value}`}
                      data-checked={checked ? 'true' : 'false'}
                      className={`group flex items-center gap-2 rounded-lg border px-2.5 py-2 text-left text-xs transition-all ${
                        checked
                          ? 'border-amber-500 bg-amber-100 text-amber-900 shadow-sm font-semibold'
                          : 'border-slate-200 bg-white hover:border-amber-300 hover:bg-amber-50 text-slate-700'
                      }`}
                    >
                      <span className={`flex h-4 w-4 shrink-0 items-center justify-center rounded border ${
                        checked ? 'border-amber-600 bg-amber-600 text-white' : 'border-slate-300 bg-white'
                      }`}>
                        {checked && <CheckCircle className="h-3 w-3" />}
                      </span>
                      <span className="text-base leading-none">{act.icon}</span>
                      <span className="truncate">{act.label}</span>
                    </button>
                  );
                })}
              </div>
            </div>

            {/* V37.26 — Identification Entreprise */}
            <div className="rounded-xl border border-slate-200 bg-slate-50/60 p-3 space-y-3">
              <div className="text-[11px] font-bold uppercase tracking-wider text-slate-600 flex items-center gap-1.5">
                <Building2 className="h-3.5 w-3.5 text-emerald-600" /> Identification entreprise
              </div>
              <div className="grid grid-cols-2 gap-3">
                <div className="space-y-1.5">
                  <Label className="text-xs font-semibold">Raison sociale</Label>
                  <Input
                    value={demandeForm.raison_sociale}
                    onChange={(e) => setDemandeForm({ ...demandeForm, raison_sociale: e.target.value })}
                    placeholder="Ex: ACME SARL"
                    data-testid="demande-form-raison-sociale"
                  />
                </div>
                <div className="space-y-1.5">
                  <Label className="text-xs font-semibold">SIRET</Label>
                  <Input
                    value={demandeForm.siret}
                    onChange={(e) => setDemandeForm({ ...demandeForm, siret: e.target.value })}
                    placeholder="14 chiffres"
                    maxLength={14}
                    data-testid="demande-form-siret"
                  />
                </div>
              </div>
            </div>

            {/* V37.26 — Demandeur (contact + adresse postale) */}
            <div className="rounded-xl border border-slate-200 bg-blue-50/40 p-3 space-y-3">
              <div className="text-[11px] font-bold uppercase tracking-wider text-slate-600 flex items-center gap-1.5">
                <Users className="h-3.5 w-3.5 text-blue-600" /> Demandeur &amp; coordonnées
              </div>
              <div className="grid grid-cols-2 gap-3">
                <div className="space-y-1.5">
                  <Label className="text-xs font-semibold">Nom</Label>
                  <Input
                    value={demandeForm.nom}
                    onChange={(e) => setDemandeForm({ ...demandeForm, nom: e.target.value })}
                    placeholder="DUPONT"
                    data-testid="demande-form-nom"
                  />
                </div>
                <div className="space-y-1.5">
                  <Label className="text-xs font-semibold">Prénom</Label>
                  <Input
                    value={demandeForm.prenom}
                    onChange={(e) => setDemandeForm({ ...demandeForm, prenom: e.target.value })}
                    placeholder="Jean"
                    data-testid="demande-form-prenom"
                  />
                </div>
              </div>
              <div className="grid grid-cols-2 gap-3">
                <div className="space-y-1.5">
                  <Label className="text-xs font-semibold">Email</Label>
                  <Input
                    type="email"
                    value={demandeForm.email}
                    onChange={(e) => setDemandeForm({ ...demandeForm, email: e.target.value })}
                    placeholder="contact@entreprise.fr"
                    data-testid="demande-form-email"
                  />
                </div>
                <div className="space-y-1.5">
                  <Label className="text-xs font-semibold">Téléphone</Label>
                  <Input
                    value={demandeForm.telephone}
                    onChange={(e) => setDemandeForm({ ...demandeForm, telephone: e.target.value })}
                    placeholder="0590..."
                    data-testid="demande-form-telephone"
                  />
                </div>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-[1fr_120px_1fr] gap-3">
                <div className="space-y-1.5">
                  <Label className="text-xs font-semibold">Adresse postale</Label>
                  <Input
                    value={demandeForm.adresse}
                    onChange={(e) => setDemandeForm({ ...demandeForm, adresse: e.target.value })}
                    placeholder="12 rue des Cocotiers"
                    data-testid="demande-form-adresse"
                  />
                </div>
                <div className="space-y-1.5">
                  <Label className="text-xs font-semibold">Code postal</Label>
                  <Input
                    value={demandeForm.code_postal}
                    onChange={(e) => setDemandeForm({ ...demandeForm, code_postal: e.target.value })}
                    placeholder="97110"
                    maxLength={5}
                    data-testid="demande-form-code-postal"
                  />
                </div>
                <div className="space-y-1.5">
                  <Label className="text-xs font-semibold">Ville</Label>
                  <Input
                    value={demandeForm.ville}
                    onChange={(e) => setDemandeForm({ ...demandeForm, ville: e.target.value })}
                    placeholder="Pointe-à-Pitre"
                    data-testid="demande-form-ville"
                  />
                </div>
              </div>
            </div>
            {/* V37.29 — Mode de publication */}
            <div className="rounded-xl border border-slate-200 bg-gradient-to-br from-indigo-50 to-purple-50/40 p-3 space-y-3" data-testid="demande-form-publication-section">
              <div className="text-[11px] font-bold uppercase tracking-wider text-slate-600 flex items-center gap-1.5">
                <Globe className="h-3.5 w-3.5 text-indigo-600" /> Mode de publication sur la Communityplace
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-2">
                {[
                  { value: 'immediat', label: 'Immédiat', icon: CheckCircle, desc: 'Publier maintenant', color: 'emerald' },
                  { value: 'differe', label: 'Différé', icon: Clock, desc: 'Publier à une date programmée', color: 'amber' },
                  { value: 'brouillon', label: 'Brouillon', icon: Archive, desc: 'Enregistrer sans publier', color: 'slate' },
                ].map((opt) => {
                  const Icon = opt.icon;
                  const active = demandeForm.publication_mode === opt.value;
                  const colorMap = {
                    emerald: active ? 'border-emerald-500 bg-emerald-100 text-emerald-900 ring-2 ring-emerald-300' : 'border-slate-200 bg-white hover:border-emerald-300',
                    amber:   active ? 'border-amber-500 bg-amber-100 text-amber-900 ring-2 ring-amber-300' : 'border-slate-200 bg-white hover:border-amber-300',
                    slate:   active ? 'border-slate-500 bg-slate-200 text-slate-900 ring-2 ring-slate-300' : 'border-slate-200 bg-white hover:border-slate-300',
                  };
                  return (
                    <button
                      type="button"
                      key={opt.value}
                      onClick={() => setDemandeForm({ ...demandeForm, publication_mode: opt.value })}
                      data-testid={`publication-mode-${opt.value}`}
                      data-active={active ? 'true' : 'false'}
                      className={`flex flex-col items-start gap-1 rounded-lg border px-3 py-2.5 text-left transition-all ${colorMap[opt.color]}`}
                    >
                      <div className="flex items-center gap-2">
                        <Icon className="h-4 w-4" />
                        <span className="font-bold text-sm">{opt.label}</span>
                      </div>
                      <span className="text-[11px] text-slate-600 leading-tight">{opt.desc}</span>
                    </button>
                  );
                })}
              </div>
              {demandeForm.publication_mode === 'differe' && (
                <div className="space-y-1.5 pt-1 border-t border-amber-200" data-testid="publication-scheduled-row">
                  <Label className="text-xs font-semibold text-amber-800">Date et heure de publication *</Label>
                  <Input
                    type="datetime-local"
                    value={demandeForm.publication_scheduled_at}
                    onChange={(e) => setDemandeForm({ ...demandeForm, publication_scheduled_at: e.target.value })}
                    min={new Date(Date.now() + 60000).toISOString().slice(0, 16)}
                    data-testid="demande-form-publication-scheduled-at"
                    className="bg-white border-amber-300"
                  />
                  <p className="text-[11px] text-amber-700">La demande deviendra visible automatiquement à la date programmée.</p>
                </div>
              )}
              {demandeForm.publication_mode === 'brouillon' && (
                <div className="text-[11px] text-slate-600 italic bg-slate-100 rounded-md px-2 py-1.5">
                  Le brouillon n'est PAS visible dans la Communityplace. Vous pourrez le publier ultérieurement.
                </div>
              )}
            </div>

            {editingDemande && (
              <div className="space-y-1.5">
                <Label className="text-xs font-semibold">Statut</Label>
                <Select value={demandeForm.statut} onValueChange={(v) => setDemandeForm({ ...demandeForm, statut: v })}>
                  <SelectTrigger><SelectValue/></SelectTrigger>
                  <SelectContent>
                    <SelectItem value="nouvelle">Nouvelle</SelectItem>
                    <SelectItem value="en_cours">En cours</SelectItem>
                    <SelectItem value="disponible">Disponible</SelectItem>
                    <SelectItem value="achetee">Achetee</SelectItem>
                    <SelectItem value="suspendue">Suspendue</SelectItem>
                  </SelectContent>
                </Select>
              </div>
            )}
            <div className="space-y-1.5">
              <Label className="text-xs font-semibold">Notes internes</Label>
              <Textarea
                rows={2}
                value={demandeForm.notes || ''}
                onChange={(e) => setDemandeForm({ ...demandeForm, notes: e.target.value })}
                placeholder="Notes (admin uniquement)..."
              />
            </div>
          </div>
          <DialogFooter>
            <Button variant="outline" onClick={() => setDemandeDialogOpen(false)}>Annuler</Button>
            <Button onClick={handleSaveAdminDemande} className={
              demandeForm.publication_mode === 'brouillon'
                ? 'bg-slate-700 hover:bg-slate-800'
                : demandeForm.publication_mode === 'differe'
                  ? 'bg-amber-600 hover:bg-amber-700'
                  : 'bg-emerald-600 hover:bg-emerald-700'
            } data-testid="demande-save-btn">
              <Save className="h-4 w-4 mr-1.5" />
              {editingDemande
                ? 'Mettre a jour'
                : demandeForm.publication_mode === 'brouillon'
                  ? 'Enregistrer en brouillon'
                  : demandeForm.publication_mode === 'differe'
                    ? 'Programmer la publication'
                    : 'Publier maintenant'}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
  );
};

export default DemandeDialog;
